export function validateFrom(rawFromURL: string): string {
  if (!rawFromURL) {
    return "From is a required field";
  }

  const [scheme, rest] = rawFromURL.split("://", 2);
  if (rest === undefined) {
    return "Invalid URL";
  }

  // #2238, port should be required for TCP connections
  if (scheme === "tcp+https") {
    if (!/:[0-9]+/.test(rest)) {
      return "TCP connections require a port";
    }
    if (rest.indexOf(":443") !== -1) {
      return "TCP connections cannot use :443 as the port";
    }
  }

  return "";
}
